import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

function PurchaseDetailsPage() {
  const history = useHistory();
  const match = useRouteMatch<{ purchaseId: string }>();
  const { purchaseId } = match.params;

  useEffect(() => {
    if (match.isExact) {
      history.replace(
        `/app/movements/purchases/purchasesReleases/${purchaseId}/general`,
      );
    }
  }, [match]);

  return null;
}

export default PurchaseDetailsPage;
